//test
export const GETmenudata = state => {
  console.log(state.isLogin)
  if (!state.isLogin) {
    state.isLogin =Boolean(sessionStorage.getItem('isLogin')); //从sessionStorage中读取状态  
    var data = sessionStorage.getItem('state');
    debugger
    if (data) {
    var data = JSON.parse(data)
    if(data.menudata){
      state.menudata = data.menudata;// 
    }
    if(data.privilegescheck){
      state.privilegescheck=data.privilegescheck 
    }
    if(data.roleList){
      state.roleList= data.roleList;// 
    }
    if(data.privileges){
      state.privileges= data.privileges;// 
    }
    if(data.setting){
      state.setting= data.setting;// 
    }
    if(data.paycode){
      state.paycode= data.paycode;//
    }
    if(data.activiId){
      state.activiId= data.activiId;//
    }
    if(data.menulist){
      state.menulist= data.menulist;//
    }
    }
  }
  return state
}

// export const privilegesbtn=btns=>{
//   var newBtns=store.state.privilegescheck;
//   if(newBtns&&newBtns.length>0){
//       if(btns&&btns.length>0){
//           btns.forEach(element => {
//               newBtns.forEach(value=>{
//                   if(value.button_id==element.button_id){
//                       element.isshow=true
//                   }
//               })
              
//           });
//       }
//   }else{
//       //没有任何权限
//   }
//   return btns 
// }



// WEBPACK FOOTER //
// ./src/vuex/getters.js